export default __webpack_public_path__ + "static/media/chasingenglish-desktop.5978b636.png";